import React, {useEffect, useState} from "react";
import WINWorker from "../../Services/WINWorker";
import {useTranslation} from "react-i18next";

export default function FavoriteItem(props) {
    const [favorited, setFavorited] = React.useState(false);
    const [isUser, setIsUser] = React.useState(false);
    const { t, i18n } = useTranslation();

    const handleFavorite = (method) => {

        if (isUser === false) {
            openSignInModal();
            return false;
        }

        if (window.all_favorites.includes(props.item.objectID)) {
            window.all_favorites.splice(window.all_favorites.indexOf(props.item.objectID), 1);
            console.log('REMOVE', props.item.objectID);
        } else {
            window.all_favorites.push(props.item.objectID);
            console.log('ADD', props.item.objectID);
        }

        let favoriteType = 'user'
        let favoriteId = props.item.objectID

        if (props.item.directory_user_type === 'Companies') {
            favoriteType = 'company'
            favoriteId = props.item.objectID.substring(2);
        }

        if (props.item.directory_user_type === 'Manufacturers Suppliers') {
            favoriteType = 'partner'
            favoriteId = props.item.objectID.substring(2);
        }

        let favoriteMethod = method === false ? 'DELETE' : 'CREATE';
        let bodyFormData = new URLSearchParams();
        bodyFormData.append('favorite_id', favoriteId);
        bodyFormData.append('favorite_type', favoriteType);
        bodyFormData.append('favorite_method', favoriteMethod);
        bodyFormData.append('csrfmiddlewaretoken', window.ajax_csrf_token);
        console.log('window.ajax_csrf_token', window.ajax_csrf_token);
        let favoriteData = {
            'favorite_id': favoriteId,
            'favorite_type': favoriteType,
            'favorite_method': favoriteMethod,
            'csrfmiddlewaretoken': window.ajax_csrf_token,
        }

        WINWorker.createOrUpdateFavorite(favoriteType, favoriteId, bodyFormData)
            .then(response => {
                console.log('response', response);
            })
            .catch(error => {
                console.log('error', error);
            });

    }

    const toggleFavorite = () => {
        if (isUser === false) {
            openSignInModal();
            return false;
        } else {
            setFavorited(!favorited);
            handleFavorite(!favorited);
        }
    };

    useEffect(() => {
        console.log('props.item.objectID', props.item.objectID);
        console.log('setFavorited', favorited);

        if (window.all_favorites.includes(props.item.objectID)) {
            console.log('cfavorite', props.item.objectID)
            setFavorited(true);
        } else {
            setFavorited(false);
        }

        if (typeof window.is_user !== 'undefined') {
            if (window.is_user === 'True') {
                setIsUser(true)
            }
        }

    });

    return (
        <a className={favorited ? 'btn-save saved' : 'btn-save'} onClick={toggleFavorite}>
            <span>{t('Directory.Save')}</span>
            <span>{t('Directory.Saved')}</span>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15.564"
                height="15.543"
                viewBox="0 0 15.564 15.543"
            >
                <g
                    id="Group_3791"
                    data-name="Group 3791"
                    transform="translate(-543.206 -1872.132)"
                >
                    <path
                        id="Path_474"
                        data-name="Path 474"
                        d="M15.33,5.369,14.4,4.436,11.128,1.167,10.194.233A.752.752,0,0,0,9.1.233a.752.752,0,0,0,0,1.089l.389.389L7.626,3.5A10.288,10.288,0,0,1,2.8,6.225a.844.844,0,0,0-.623.623.958.958,0,0,0,.389.778,17.224,17.224,0,0,1,2.49,1.79L.233,14.241a.752.752,0,0,0,0,1.089.8.8,0,0,0,1.089,0l4.825-4.825c.545.7,1.089,1.479,1.79,2.49a.819.819,0,0,0,.778.389.844.844,0,0,0,.623-.623,10.936,10.936,0,0,1,2.724-4.9l1.79-1.79s.545.623.934.623a.706.706,0,0,0,.545-.233A.752.752,0,0,0,15.33,5.369Zm-4.358,1.4a12.233,12.233,0,0,0-2.646,3.969,13.061,13.061,0,0,0-3.58-3.58A11.46,11.46,0,0,0,8.716,4.513l1.79-1.79L12.684,4.9Z"
                        transform="translate(543.206 1872.132)"
                        fill="#2c271c"
                    ></path>
                </g>
            </svg>

            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15.564"
                height="15.543"
                viewBox="0 0 15.564 15.543"
            >
                <g
                    id="Group_3791"
                    data-name="Group 3791"
                    transform="translate(-543.206 -1872.132)"
                >
                    <path
                        id="Path_474"
                        data-name="Path 474"
                        d="M15.33,5.369,14.4,4.436,11.128,1.167,10.194.233A.752.752,0,0,0,9.1.233a.752.752,0,0,0,0,1.089l.389.389L7.626,3.5A10.288,10.288,0,0,1,2.8,6.225a.844.844,0,0,0-.623.623.958.958,0,0,0,.389.778,17.224,17.224,0,0,1,2.49,1.79L.233,14.241a.752.752,0,0,0,0,1.089.8.8,0,0,0,1.089,0l4.825-4.825c.545.7,1.089,1.479,1.79,2.49a.819.819,0,0,0,.778.389.844.844,0,0,0,.623-.623,10.936,10.936,0,0,1,2.724-4.9l1.79-1.79s.545.623.934.623a.706.706,0,0,0,.545-.233A.752.752,0,0,0,15.33,5.369Z"
                        transform="translate(543.206 1872.132)"
                        fill="#5b7e2d"
                    ></path>
                </g>
            </svg>
        </a>
    );
}
